<template>
  <div class="general">
    <filtro-cadu
      v-model="valueData"
      style="height: 100%;"
      @limparFiltro="limparFiltro()"
      @filtrar="filtraAnexos()"
      @input="(value) => closeFilter(value)"
    >
      <div slot="body" class="filtro-consulta">
        <v-row class="mx-2">
          <v-col cols="auto">
            <div class="fontColor1--text">
              BUSCAR UNIMED
            </div>
          </v-col>
        </v-row>
        <ValidationObserver ref="observer">
          <v-row class="px-5">
            <v-col cols="12">
              <validation-provider name="buscarUnimed" mode="eager" v-slot="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Buscar Unimed"
                  v-model="buscarUnimed"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="buscarHierarquia" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaHierarquia.map((el) => el.textoExibicao)"
                  :errorMessage="errors[0]"
                  title="Buscar Hierarquia"
                  v-model="hierarquiaSelecionada"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="tipoCooperativa" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaTipoCooperativa.map((el) => el.nome)"
                  :errorMessage="errors[0]"
                  title="Tipo de Cooperativa"
                  v-model="tipoCooperativaSelecionada"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="tipoFederacao" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaTipoFederacao.map((el) => el.nome)"
                  :errorMessage="errors[0]"
                  title="Tipo de Federação"
                  v-model="tipoFederacaoSelecionada"
                  :disabled="desabilitarInputFederacao"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="tipoAtuacao" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaTipoAtuacao.map((el) => el.nome)"
                  :errorMessage="errors[0]"
                  title="Tipo de Atuação"
                  v-model="tipoAtuacaoSelecionada"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="grauCooperativa" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaGrauCooperativa.map((el) => el.nome)"
                  :errorMessage="errors[0]"
                  title="Grau da Cooperativa"
                  v-model="grauCooperativaselecionada"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="registroANS" rules="numeric" mode="eager" v-slot="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Registro ANS"
                  v-model="registroANS"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  onlyNumber
                  max="6"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="porte" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaPorte.map((el) => el.nome)"
                  :errorMessage="errors[0]"
                  title="Porte"
                  v-model="porteSelecionado"
                />
              </validation-provider>
            </v-col>
            <v-col cols="4">
              <validation-provider name="uf" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaUF.map((el) => el.sigla)"
                  :errorMessage="errors[0]"
                  title="UF"
                  v-model="ufSelecionado"
                />
              </validation-provider>
            </v-col>
            <v-col cols="8">
              <validation-provider name="regiaoGeografica" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaRegiaoGeografica.map((el) => el.nome)"
                  :errorMessage="errors[0]"
                  title="Região Geográfica"
                  v-model="regiaoGeograficaSelecionada"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="municipio" mode="eager" v-slot="{ errors }">
                <autocomplete-cadu
                  :items="listaMunicipio.map((el) => el.municipioEstado)"
                  :errorMessage="errors[0]"
                  title="Município"
                  v-model="municipio"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider name="nomeDirigente" mode="eager" v-slot="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Dirigente"
                  v-model="nomeDirigente"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="auto">
                  <div class="fontColor1--text situacao-atual">
                    Situação Atual
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <checkbox-cadu v-model="ativo" rounded>
                    <div slot="text">
                      Ativa
                    </div>
                  </checkbox-cadu>
                </v-col>
                <v-col cols="5">
                  <checkbox-cadu v-model="inativo" rounded>
                    <div slot="text">
                      Inativa
                    </div>
                  </checkbox-cadu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
    </filtro-cadu>
    <error-modal v-model="error" :errObj="errObj" />
    <overlay-loading v-model="loadingOverlay" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import ListarUnimed from '@/services/Unimed/ListarUnimed'
import TipoUnimed from '@/services/Dominios/TipoUnimed'
import TipoFederacao from '@/services/Dominios/TipoFederacao'
import TipoAtuacao from '@/services/Dominios/TipoAtuacao'
import GrauCooperativa from '@/services/Dominios/GrauCooperativa'
import Porte from '@/services/Dominios/Porte'
import Estado from '@/services/AreaAcao/Estado'
import ListaMunicipios from '../../../services/Dominios/ListaMunicipios'
import RegiaoGeografica from '@/services/Dominios/RegiaoGeografica'
import Dirigentes from '@/services/Dirigentes/Dirigentes'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      valueData: this.value,

      buscarUnimed: '',
      listaHierarquia: [],
      hierarquiaSelecionada: '',
      listaTipoCooperativa: [],
      tipoCooperativaSelecionada: '',
      listaTipoFederacao: [],
      tipoFederacaoSelecionada: '',
      listaTipoAtuacao: [],
      tipoAtuacaoSelecionada: '',
      listaGrauCooperativa: [],
      grauCooperativaselecionada: '',
      registroANS: '',
      listaPorte: [],
      porteSelecionado: '',
      listaUF: [],
      ufSelecionado: '',
      listaRegiaoGeografica: [],
      regiaoGeograficaSelecionada: '',
      listaMunicipio: [],
      municipio: '',
      nomeDirigente: '',
      ativo: false,
      inativo: false,
      desabilitarInputFederacao: false,
      barraPesquisa: '',
      error: false,
      errObj: {},
      pesquisaNova: [],
      loadingOverlay: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.getDominios()
  },
  methods: {
    getDominios() {
      this.getHierarquia()
      this.getTipoCooperativa()
      this.getTipoFederacao()
      this.getTipoAtuacao()
      this.getGrauCooperativa()
      this.getPorte()
      this.getEstado()
      this.getMunicipios()
      this.getRegiao()
    },
    async pesquisar() {
      if (!this.barraPesquisa) return
      this.loadingOverlay = true

      const dirigente = new Dirigentes(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        const res = await dirigente.getPesquisa(this.barraPesquisa)
        if (res.data.length === 0) {
          this.error = true
          this.errObj.error = 'Médico ou não médico cooperado não localizado!'
        } else {
          await this.$nextTick
          this.$refs.barraPesquisa.mostrarMenu = true
          this.pesquisaNova = res.data
        }
      } catch (err) {
        this.pesquisaNova = []
      } finally {
        this.loadingOverlay = false
      }
    },
    async preencherCampos(dirigente) {
      await this.$nextTick()
      if (!dirigente) return
      this.idDirigente = dirigente.id
    },
    async getHierarquia() {
      let listarUnimed = new ListarUnimed(this.tokenBearer, this.$appConfig.config.API)

      await listarUnimed
        .getConfederacaoAndFederacao()
        .then(({ data }) => {
          this.listaHierarquia = data
        })
        .catch((err) => {
          console.error(err)
          this.listaHierarquia = []
        })
    },
    async getTipoCooperativa() {
      let tipoUnimed = new TipoUnimed(this.tokenBearer, this.$appConfig.config.API)

      await tipoUnimed
        .getTipoUnimed()
        .then(({ data }) => {
          this.listaTipoCooperativa = data
        })
        .catch((err) => {
          console.error(err)
          this.listaTipoCooperativa = []
        })
    },
    async getTipoFederacao() {
      let tipoFederacao = new TipoFederacao(this.tokenBearer, this.$appConfig.config.API)

      await tipoFederacao
        .getTipoFederacao()
        .then(({ data }) => {
          this.listaTipoFederacao = data
        })
        .catch((err) => {
          console.error(err)
          this.listaTipoFederacao = []
        })
    },
    async getTipoAtuacao() {
      let tipoAtuacao = new TipoAtuacao(this.tokenBearer, this.$appConfig.config.API)

      await tipoAtuacao
        .getTipoAtuacao()
        .then(({ data }) => {
          this.listaTipoAtuacao = data
        })
        .catch((err) => {
          console.error(err)
          this.listaTipoAtuacao = []
        })
    },
    async getGrauCooperativa() {
      let grauCooperativa = new GrauCooperativa(this.tokenBearer, this.$appConfig.config.API)

      await grauCooperativa
        .getGrauCooperativa()
        .then(({ data }) => {
          this.listaGrauCooperativa = data
        })
        .catch((err) => {
          console.error(err)
          this.listaGrauCooperativa = []
        })
    },
    async getPorte() {
      let porte = new Porte(this.tokenBearer, this.$appConfig.config.API)

      await porte
        .getPortes()
        .then(({ data }) => {
          this.listaPorte = data
        })
        .catch((err) => {
          console.error(err)
          this.listaPorte = []
        })
    },
    async getEstado() {
      let estado = new Estado(this.tokenBearer, this.$appConfig.config.API)

      await estado
        .getEstados()
        .then(({ data }) => {
          this.listaUF = data
        })
        .catch((err) => {
          console.error(err)
          this.listaUF = []
        })
    },
    async getMunicipios() {
      let municipio = new ListaMunicipios(this.tokenBearer, this.$appConfig.config.API)

      await municipio
        .getAllMunicipios()
        .then(({ data }) => {
          this.listaMunicipio = data
        })
        .catch((err) => {
          console.error(err)
          this.listaMunicipio = []
        })
    },
    async getMunicipiosPorEstado(id) {
      let municipio = new ListaMunicipios(this.tokenBearer, this.$appConfig.config.API)

      await municipio
        .getMunicipio(id)
        .then(({ data }) => {
          this.listaMunicipio = data
        })
        .catch((err) => {
          console.error(err)
          this.listaMunicipio = []
        })
    },
    async getRegiao() {
      let regiaoGeografica = new RegiaoGeografica(this.tokenBearer, this.$appConfig.config.API)

      await regiaoGeografica
        .getRegioes()
        .then(({ data }) => {
          this.listaRegiaoGeografica = data
        })
        .catch((err) => {
          console.error(err)
          this.listaRegiaoGeografica = []
        })
    },
    async getRegiaoPorEstado(id) {
      let regiao = new RegiaoGeografica(this.tokenBearer, this.$appConfig.config.API)

      await regiao
        .getEstado(id)
        .then(({ data }) => {
          this.listaRegiaoGeografica = data
        })
        .catch((err) => {
          console.error(err)
          this.listaRegiaoGeografica = []
        })
    },
    filtraAnexos() {
      let filtro = this.montarFiltro()
      this.$emit('filtrar', filtro)
      this.valueData = false
    },
    montarFiltro() {
      let filtro = {
        buscarUnimed: this.verificarValor(this.buscarUnimed),
        buscarHierarquia: this.verificarValorHierarquia(this.listaHierarquia, this.hierarquiaSelecionada),
        tipoCooperativa: this.verificarValorEmLista(this.listaTipoCooperativa, this.tipoCooperativaSelecionada),
        tipoFederacao: this.verificarValorEmLista(this.listaTipoFederacao, this.tipoFederacaoSelecionada),
        tipoAtuacao: this.verificarValorEmLista(this.listaTipoAtuacao, this.tipoAtuacaoSelecionada),
        grauCooperativa: this.verificarValorEmLista(this.listaGrauCooperativa, this.grauCooperativaselecionada),
        registroANS: this.verificarValor(this.registroANS),
        porte: this.verificarValorEmLista(this.listaPorte, this.porteSelecionado),
        uf: this.verificarValorUF(this.listaUF, this.ufSelecionado),
        regiaoGeografica: this.verificarValorEmLista(this.listaRegiaoGeografica, this.regiaoGeograficaSelecionada),
        municipio: this.verificarValorEmMunicipio(this.listaMunicipio, this.municipio),
        nomeDirigente: this.verificarValor(this.nomeDirigente),
        ativa: this.verificarValorSituacao()
      }
      return filtro
    },
    verificarValor(valor) {
      return valor || ''
    },
    verificarValorEmLista(lista, valor) {
      let obj = lista.find((item) => item.nome === valor)
      return obj ? obj.id : ''
    },
    verificarValorUF(lista, valor) {
      let obj = lista.find((item) => item.sigla === valor)
      return obj ? obj.id : ''
    },
    verificarValorHierarquia(lista, valor) {
      let obj = lista.find((item) => item.textoExibicao === valor)
      return obj ? obj.id : ''
    },
    verificarValorEmMunicipio(lista, valor) {
      let obj = lista.find((item) => item.municipioEstado === valor)
      return obj ? obj.id : ''
    },
    verificarValorSituacao() {
      if (this.inativo) {
        return false
      } else if (this.ativo) {
        return true
      } else {
        return null
      }
    },
    limparFiltro() {
      this.buscarUnimed = ''
      this.hierarquiaSelecionada = ''
      this.tipoCooperativaSelecionada = ''
      this.tipoFederacaoSelecionada = ''
      this.tipoAtuacaoSelecionada = ''
      this.grauCooperativaselecionada = ''
      this.registroANS = ''
      this.porteSelecionado = ''
      this.ufSelecionado = ''
      this.regiaoGeograficaSelecionada = ''
      this.municipio = ''
      this.nomeDirigente = ''
      this.ativo = false
      this.inativo = false
      this.barraPesquisa = ''
    },
    closeFilter(value) {
      if (!value) {
        this.$emit('close')
      }
    }
  },
  watch: {
    value() {
      this.valueData = this.value
    },
    ativo() {
      if (this.ativo) {
        this.inativo = false
      }
    },
    inativo() {
      if (this.inativo) {
        this.ativo = false
      }
    },
    tipoCooperativaSelecionada() {
      switch (this.tipoCooperativaSelecionada) {
        case 'CONFEDERAÇÃO':
        case 'FEDERAÇÃO':
          this.desabilitarInputFederacao = false
          this.tipoFederacaoSelecionada = ''
          break
        case '':
        case null:
          this.desabilitarInputFederacao = false
          this.tipoFederacaoSelecionada = ''
          break
        default:
          this.desabilitarInputFederacao = true
          this.tipoFederacaoSelecionada = ''
      }
    },
    ufSelecionado() {
      if (this.ufSelecionado) {
        this.getMunicipiosPorEstado(this.verificarValorUF(this.listaUF, this.ufSelecionado))
        this.getRegiaoPorEstado(this.verificarValorUF(this.listaUF, this.ufSelecionado))
      } else {
        this.getMunicipios()
        this.getRegiao()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.general
    color: rgba(0, 0, 0, 0.54)
    font-size: 0.875rem
    line-height: 1.375rem
    letter-spacing: 0.0071428571em
    z-index: 999999999999999
    position: fixed

.filtro-consulta
    height: 100%
    overflow-x: hidden
    overflow-y: auto

.situacao-atual
    font-size: 1.1em
</style>
